import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import { useLocation, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import MantTransactionCredit from "./components/MantTransactionCredit";
import GestionTransaccionesModal from "../../global/modals/GestionTransaccionesModal";
const MySwal = withReactContent(Swal);

const PageTransactionCredit = () => {
    const location = useLocation();
       

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [tiposDocumento, setTiposDocumento] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [metodosPago, setMetodosPago] = useState(CONFIGURACIONES.INIT.ARRAY);

    const [usuario, setUsuario] = useState(CONFIGURACIONES.INIT.NULL);
    const [dataCreditos, setDataCreditos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [solicitudId, setSolicitudId] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [showTransaction, setShowTransaction] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [elementActive, setElementActive] = useState(CONFIGURACIONES.INIT.NULL);
    const [solicitud, setSolicitud] = useState(CONFIGURACIONES.INIT.NULL);
   
    const [cliente, setCliente] = useState(CONFIGURACIONES.INIT.NULL);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);

    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();

    const loadData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setTiposDocumento(rpta.data.tiposDocumento);
                setMetodosPago(rpta.data.metodosPago);
            }
        });
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const searchCredit = () => {
        let tipoBusqueda = document.getElementById('tipoBusqueda').value;
        let tipoDocumentoId = document.getElementById('tipoDocumentoId')?.value;
        let numeroDocumento = document.getElementById('numeroDocumento')?.value;
        let numSolicitud = document.getElementById('numSolicitud')?.value;

        if (!tipoBusqueda) {
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `Indique Tipo de búsqueda`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });
            return;
        }

        let data = {
            body: {
                'tipoBusqueda': tipoBusqueda,
                'tipoDocumentoId': tipoDocumentoId,
                'numeroDocumento': numeroDocumento,
                'numSolicitud': numSolicitud,
                'usuarioRegistro': getUser().user,
            }
        }

        setDataCreditos(CONFIGURACIONES.INIT.ARRAY);
        setCliente(CONFIGURACIONES.INIT.NULL);
        setSolicitudId(CONFIGURACIONES.INIT.NUMBER);
        setElementActive(CONFIGURACIONES.INIT.NULL);
        Http().post(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/buscar-creditos`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDataCreditos(rpta.data.creditos);
                setCliente(rpta.data.cliente);
            } else {
                MySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(rpta.errors).length?Functions().showErrors(rpta.errors):rpta.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    const handleCheck = (idx) => {
        setSolicitudId(idx);
    };

    const handleCronograma = () => {
        setShowTransaction(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const closeTransactionModal = () => {
        setShowTransaction(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnReturnExtornoDesembolso = () => {
        searchCredit();
    };

    const handleExtornar = async () => {
        if (solicitudId === CONFIGURACIONES.INIT.NUMBER) { return; }
        await Functions().extornoElement(`${CONFIGURACIONES.ENDPOINTS.TRANSACCIONES_CREDITO}/extornar-desembolso/${solicitudId}`, CONFIGURACIONES.MESSAGES.SUCCESS_EXTORN_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.SOLICITUD_DESEMBOLSO} <strong>${elementActive.numSolicitud}</strong> y monto: <strong>${elementActive.montoSolicitado}</strong>`, getUser(), fnReturnExtornoDesembolso, {});
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        showSpinnerLoader();
        loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        // loadData();
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        // console.log('componentes', componentes);
        
    }, [location.pathname])
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantTransactionCredit title={'Gestión de Transacciones de Crédito'} idEdit={idRef} MySwal={MySwal} setUsuario={setUsuario} icon={iconActive} dataCreditos={dataCreditos}
                                        setIdRef={setIdRef} usuario={usuario} cliente={cliente} tiposDocumento={tiposDocumento} fnBuscar={searchCredit} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)}  solicitudId={solicitudId} handleCheck={handleCheck} handleCronograma={handleCronograma} handleExtornar={handleExtornar} setElementActive={setElementActive} solicitud={solicitud}/>
                                </div>
                            </div>
                            <GestionTransaccionesModal show={showTransaction} onClose={closeTransactionModal} showDescuento={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} showPagar={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} title={"Gestión de Transacciones del Crédito"} metodosPago={metodosPago} solicitudId={solicitudId} user={getUser()} setSolicitud={setSolicitud} solicitud={solicitud} />
                        </div>
                    )}
                       
                </div>
            </div>
        </div>
    )
}

export default PageTransactionCredit;